import { render, staticRenderFns } from "./flowRecord.vue?vue&type=template&id=c79f9e8c&scoped=true"
import script from "./flowRecord.vue?vue&type=script&lang=js"
export * from "./flowRecord.vue?vue&type=script&lang=js"
import style0 from "./flowRecord.vue?vue&type=style&index=0&id=c79f9e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79f9e8c",
  null
  
)

export default component.exports